import {
    Avatar,
    Button,
    Checkbox,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    MenuItem,
    Radio,
    Select,
    TextField,
} from "@material-ui/core";
import { CloseRounded } from "@material-ui/icons";
import ShoppingCartOutlinedIcon from "@material-ui/icons/ShoppingCartOutlined";
import React, { useEffect, useRef, useState } from "react";
import {
    Accordion,
    AccordionItem,
    AccordionItemButton,
    AccordionItemHeading,
    AccordionItemPanel,
} from "react-accessible-accordion";
import ReactFlagsSelect from "react-flags-select";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import _ from "underscore";
import uploadingImg from "../../assets/images/calculator.png";
import {
    geocodeResponseToCityState,
    IsNullOrEmpty,
    validEmail,
    validPhone,
} from "../../helpers/utility";
import {
    getCartRequest,
    updateCartRequest,
} from "../../store/shopping/shopping.actions";
import { getCartList } from "../../store/shopping/shopping.selector";
import { getDeliveryAddressRequest } from "../../store/user/deliveryaddress/deliveryaddress.actions";
import DeliveryAddressAPI from "../../store/user/deliveryaddress/deliveryaddress.api";
import { getDeliveryAddresses } from "../../store/user/deliveryaddress/deliveryaddress.selector";
import { getImage, getUserProfile } from "../../store/user/user.selector";
import OrderPayment from "./order_payment";

var api_key = process.env.REACT_APP_GOOGLE_API_KEY;
var currency = "";
var myProps = {};

const Cart = (props) => {
    const location = useLocation();
    const scrollRef = useRef(null);
    const [shipment, setShipment] = useState({});
    const [courier, setCourier] = useState({});
    const [discounts, setDiscounts] = useState({});
    const [selectedAddress, setSelectedAddress] = useState("");
    const [confirmPayment, setConfirmPayment] = useState(false);
    const [mode, setMode] = useState("Checkout");
    const [validationError, setValidationError] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [selectedItems, setSelectedItems] = useState([]);
    const [openCourier, setOpenCourier] = useState(false);
    const [calculating, setCalculating] = useState(false);
    const [rates, setRates] = useState([]);
    const [selectedRate, setSelectedRate] = useState({});
    const [name, setName] = useState("");
    const [discountCode, setDiscountCode] = useState("");
    const [selectedProduct, setSelectedProduct] = useState("");
    const [phone, setPhone] = useState("");
    const [address, setAddress] = useState("");
    const [address1, setAddress1] = useState("");
    const [city, setCity] = useState("");
    const [postCode, setPostCode] = useState("");
    const [cities, setCities] = useState([]);
    const [isSeller, setIsSeller] = useState(false);
    const [states, setStates] = useState([]);
    const [email, setEmail] = useState("");
    const [state, setCurState] = useState("");
    const [nickName, setNickName] = useState("");
    const [isNew, setNew] = useState(false);
    const [status, setStatus] = useState("Active");
    const [selected, setSelected] = useState("MY");
    const [countryCode, setCountry] = useState("+60");
    const [form, setForm] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [selectedIndex, setSelectedIndex] = React.useState("");

    const [accordionOne, setAccordionOne] = useState(true);
    const [accordionTwo, setAccordionTwo] = useState(false);

    const handleAccordionOne = (e) => {
        const accordionToggle = document
            .querySelector(".accordionToggleOne")
            .getAttribute("aria-expanded");
        if (accordionToggle === "true") {
            setAccordionOne(true);
        } else {
            setAccordionOne(false);
        }
    };
    const handleAccordionTwo = (e) => {
        const accordionToggle = document
            .querySelector(".accordionToggleTwo")
            .getAttribute("aria-expanded");
        if (accordionToggle === "true") {
            setAccordionTwo(true);
        } else {
            setAccordionTwo(false);
        }
    };
    const dispatch = useDispatch();

    const getCountryByCode = (code) => {
        if (code == "+65") return "SG";
        if (code == "+60") return "MY";
        if (code == "+1") return "US";
    };

    useEffect(() => {
        if (mode === "Address" && !IsNullOrEmpty(selectedAddress._id)) {
            setCalculating(true);
            let ids = selectedItems.map((x) => x.product && x.product.user.id);
            let curItems = selectedItems;
            DeliveryAddressAPI.GetSellerAddress({
                ids: ids,
            })
                .then((res) => {
                    let shipment = ids.map((y, index) => {
                        let addr = _.find(res.data, (s) => s.user === y);
                        if (!addr) {
                            Swal.fire({
                                icon: "warning",
                                title: "Seller zip code not available",
                                text: "Seller didn't configured the zip code.Please try again later",
                                customClass: {
                                    cancelButton: "order-1 right-gap",
                                    confirmButton: "order-2",
                                    denyButton: "order-3",
                                },
                            });
                            setValidationError(true);
                        }
                        return {
                            pick_code: addr.postCode,
                            pick_country: getCountryByCode(addr.country),
                            send_code: addr.postCode,
                            send_country: getCountryByCode(addr.country),
                            weight: selectedItems[index].product.weight,
                            height: selectedItems[index].product.height,
                            length: selectedItems[index].product.length,
                            width: selectedItems[index].product.width,
                        };
                    });
                    DeliveryAddressAPI.GetShippingAmount(shipment)
                        .then((x) => {
                            let ship = {};
                            let discou = {};
                            let rt = {};
                            let curir = {};
                            if (x.data) {
                                x.data.result.forEach((y, index) => {
                                    let dv = y.rates.filter(
                                        (yt) =>
                                            yt.service_detail.indexOf(
                                                "dropoff"
                                            ) > -1
                                    );

                                    if (dv.length > 0) {
                                        ship[curItems[index].product._id] =
                                            dv[0].shipment_price;
                                        curir[curItems[index].product._id] =
                                            dv[0].courier_name;
                                        discou[curItems[index].product._id] = 0;
                                        curItems[index].product.shippingFee =
                                            dv[0].shipment_price;
                                        curItems[index].product.discount = 0;
                                        rt[curItems[index].product._id] =
                                            dv[0].rate_id;
                                    }
                                });
                                setSelectedRate(rt);
                                setRates(x.data.result);
                                setSelectedItems(curItems);
                                setCalculating(false);
                                setShipment(ship);
                                setDiscounts(discou);
                                setCourier(curir);
                            }
                        })
                        .catch(() => {
                            setCalculating(false);
                        });
                })
                .catch(() => {
                    setCalculating(false);
                });
        }
    }, [mode, selectedAddress]);

    useEffect(() => {
        if (location && location.state && location.state.checkout) {
            if (carts.cartItems && carts.cartItems.length > 0) {
                let cartItems = carts.cartItems.filter((x) => {
                    return x.product._id === location.state.product;
                });
                setMode("Address");
                setSelectedItems(cartItems);
            }
        }
    }, [location]);

    const handleSelect = (code) => {
        setSelected(code);
        if (code === "SG") setCountry("+65");
        if (code === "MY") setCountry("+60");
        if (code === "US") setCountry("+1");
    };

    const handleChecked = (item, isChecked) => {
        if (isChecked) {
            setSelectedAddress(item);
        } else {
            setSelectedAddress({});
        }
    };

    const { carts, deliveryAddresses, userProfile } = useSelector((state) => {
        return {
            carts: getCartList(state),
            deliveryAddresses: getDeliveryAddresses(state),
            userProfile: getUserProfile(state),
        };
    });

    useEffect(() => {
        let defaultAdd = _.find(deliveryAddresses, (s) => s.isDefault === true);
        if (defaultAdd) {
            setSelectedAddress(defaultAdd);
        }
    }, [deliveryAddresses]);

    useEffect(() => {
        setName("");
        setNickName("");
        setPhone("");
        setAddress("");
        setAddress1("");
        setPostCode("");
        setCurState("");
        setEmail("");
        setCity("");
        setForm(false);
    }, [isNew]);

    useEffect(() => {
        dispatch(getCartRequest());
        dispatch(getDeliveryAddressRequest());
    }, []);

    useEffect(() => {
        let curItems = selectedItems;

        curItems = selectedItems.map((x) => {
            let productCodes = carts.cartItems.filter(
                (y) => y.product.code === x.product.code
            );
            if (productCodes.length > 0) {
                x.quantity = productCodes[0].quantity;
            }
            return x;
        });
        if (mode === "Address") {
            if (location && location.state && location.state.checkout) {
                if (carts.cartItems.length > 0) {
                    let cartItems = carts.cartItems.filter((x) => {
                        return x.product._id === location.state.product;
                    });
                    setMode("Address");
                    setSelectedItems(cartItems);
                }
            }
        } else {
            setSelectedItems(curItems);
        }
    }, [carts]);

    const validate = () => {
        return (
            !IsNullOrEmpty(name) &&
            !IsNullOrEmpty(address) &&
            !IsNullOrEmpty(address1) &&
            !IsNullOrEmpty(city) &&
            !IsNullOrEmpty(state) &&
            !IsNullOrEmpty(postCode) &&
            !IsNullOrEmpty(phone) &&
            !IsNullOrEmpty(email) &&
            validPhone(phone) &&
            validEmail(email)
        );
    };

    const handleSave = () => {
        if (validate()) {
            let data = {
                name: name,
                phone: countryCode + phone,
                address: address,
                subAddress: address1,
                city: city,
                isDefault: true,
                isSeller: false,
                postCode: postCode,
                status: status,
                state: state,
                country: countryCode,
                nickName: IsNullOrEmpty(nickName) ? name : nickName,
                email: email,
            };

            DeliveryAddressAPI.CreateDeliveryAddress(data).then((x) => {
                dispatch(getDeliveryAddressRequest());
                setSelectedAddress(x.data);
                setNew(false);
            });
        } else {
            setForm(true);
        }
    };

    const updateCartProductItem = (id, qty, isAdd) => {
        if (isAdd) {
            qty = qty + 1;
        } else {
            qty = qty - 1;
        }
        dispatch(
            updateCartRequest({
                product: id,
                quantity: qty,
            })
        );
    };

    const handleDelete = (id) => {
        dispatch(
            updateCartRequest({
                product: id,
                quantity: 0,
            })
        );
    };

    let cartList = [];
    if (carts && carts.cartItems) {
        cartList = carts.cartItems;
    }

    if (!IsNullOrEmpty(searchText)) {
        cartList = cartList.filter((item) => {
            return (
                item.product.user.userName
                    .toLowerCase()
                    .indexOf(searchText.toLowerCase()) > -1 ||
                item.product.code
                    .toLowerCase()
                    .indexOf(searchText.toLowerCase()) > -1 ||
                item.product.name
                    .toLowerCase()
                    .indexOf(searchText.toLowerCase()) > -1 ||
                item.product.descriptions
                    .toLowerCase()
                    .indexOf(searchText.toLowerCase()) > -1
            );
        });
    }

    let prices = selectedItems.map((x) => {
        return x.product.price * x.quantity;
    });

    let shippingPrices = selectedItems.map((x) => {
        return x.product.shippingFee * x.quantity;
    });

    let qtys = selectedItems.map((x) => {
        return x.quantity;
    });

    let totalProductPrice = _.reduce(
        prices,
        function (memo, num) {
            return memo + num;
        },
        0
    );
    let totalShippingFee = _.reduce(
        shippingPrices,
        function (memo, num) {
            return memo + num;
        },
        0
    );

    let discountPrices = selectedItems.map((x) => {
        return x.product.discount * x.quantity;
    });

    let totalDiscount = _.reduce(
        discountPrices,
        function (memo, num) {
            return memo + num;
        },
        0
    );
    let orderTotal = _.reduce(
        qtys,
        function (memo, num) {
            return memo + num;
        },
        0
    );

    const scrollH = (e) => {
        e = window.event || e;
        let delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
        scrollRef.current.scrollLeft -= delta * 40;
    };

    if (cartList.length === 0) {
        return (
            <div className="p-2 sm:p-4 lg:px-8 h-full overflow-hidden flex flex-col">
                <div className="">
                    <div className="mb-3">
                        <h2 className="text-xl font-bold text-ebony-color capitalize">
                            cart
                        </h2>
                        <p className="text-md font-medium text-black-60">
                            Your add-to-cart items that are ready for checkout
                        </p>
                    </div>
                    <div className="p-4 pb-0 h-[70vh] flex items-center justify-center bg-white rounded-lg border border-b-0 border-black-10">
                        <p className="text-center text-lg text-black-50">
                            <ShoppingCartOutlinedIcon
                                className="text-black-50"
                                style={{ fontSize: "10rem" }}
                                fontSize="large"
                            />
                            <br />
                            You have no items in your shopping cart.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="p-2 sm:p-4 lg:px-8 h-full overflow-hidden flex flex-col">
            <Dialog open={calculating}>
                <DialogContent>
                    <div className="flex flex-col items-center justify-center mt-4 h-full">
                        <img src={uploadingImg} />
                        <p className="text-xl font-bold text-ebony-color capitalize">
                            Calculating...
                        </p>
                        <p className="text-md font-medium text-black-50 mt-3">
                            We’re calculating shipping fee
                        </p>
                    </div>
                </DialogContent>
            </Dialog>
            <div className="">
                <div className="mb-3">
                    <h2 className="text-xl font-bold text-ebony-color capitalize">
                        cart
                    </h2>
                    <p className="text-md font-medium text-black-60">
                        Your add-to-cart items that are ready for checkout
                    </p>
                </div>

                <div className="p-4 pb-0 bg-white rounded-lg rounded-br-none rounded-bl-none border border-b-0 border-black-10">
                    <ul
                        onWheel={(e) => scrollH(e)}
                        ref={scrollRef}
                        className="flex items-center pb-[6px] border-b border-black-10 overflow-x-auto no-scrollbar"
                    >
                        <li>
                            <NavLink
                                onClick={() => setMode("Checkout")}
                                className={`text-md font-medium ${
                                    mode === "Checkout"
                                        ? "text-orange-color border-b-2  border-orange-color pb-[7px]"
                                        : "text-black-60"
                                } hover:pb-[7px] px-6 hover:border-b-2 capitalize  whitespace-nowrap`}
                            >
                                Checkout
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                disabled={selectedItems.length === 0}
                                onClick={() => {
                                    if (selectedItems.length > 0) {
                                        setMode("Address");
                                    }
                                }}
                                className={`text-md font-medium ${
                                    mode === "Address"
                                        ? "text-orange-color border-b-2  border-orange-color pb-[7px]"
                                        : "text-black-60"
                                } hover:pb-[7px] px-6 hover:border-b-2 capitalize  whitespace-nowrap`}
                            >
                                Address details
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                disabled={
                                    (IsNullOrEmpty(selectedAddress._id) &&
                                        !isNew) ||
                                    calculating ||
                                    validationError
                                }
                                onClick={() => {
                                    if (
                                        selectedItems.length > 0 &&
                                        !IsNullOrEmpty(selectedAddress._id)
                                    ) {
                                        setMode("Payment");
                                    }
                                }}
                                className={`text-md font-medium ${
                                    mode === "Payment"
                                        ? "text-orange-color border-b-2 border-orange-color pb-[7px]"
                                        : "text-black-60"
                                } hover:pb-[7px] px-6 hover:border-b-2 capitalize  whitespace-nowrap`}
                            >
                                Payment details
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="flex-grow overflow-y-auto p-4 bg-white rounded-lg rounded-tr-none rounded-tl-none border border-t-0 border-black-10">
                {mode === "Checkout" ? (
                    <div>
                        <div className="relative mb-3.5">
                            <input
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                type="search"
                                className="py-2.5 pl-12 w-full text-black-color placeholder:text-black-60 border border-black-10 rounded-[40px] text-md sm:text-md outline-none"
                                placeholder="Search"
                            />

                            <span className="text-xl absolute top-2/4 -translate-y-2/4 left-5 text-black-60">
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2ZM0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 7.29583 11.5892 8.49572 10.8907 9.47653L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L9.47653 10.8907C8.49572 11.5892 7.29583 12 6 12C2.68629 12 0 9.31371 0 6Z"
                                        fill="black"
                                        fillOpacity="0.5"
                                    />
                                </svg>
                            </span>
                        </div>

                        <div className="w-full text-md text-left">
                            <div className=" capitalize  text-md font-medium text-black-60">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center">
                                        <div className="pr-2">
                                            <div className="flex items-center">
                                                <Checkbox
                                                    checked={
                                                        selectedItems.length >=
                                                        cartList.length
                                                    }
                                                    onChange={(e) => {
                                                        if (!e.target.checked) {
                                                            setSelectedItems(
                                                                []
                                                            );
                                                        } else {
                                                            setSelectedItems(
                                                                cartList
                                                            );
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="py-3">items</div>
                                    </div>
                                    <div className="py-3 text-right">Total</div>
                                </div>
                            </div>
                            <div className="space-y-10 lg:space-x-0">
                                {cartList &&
                                    cartList.map((x) => {
                                        let isActive =
                                            selectedItems.filter(
                                                (y) =>
                                                    y.product._id ===
                                                    x.product._id
                                            ).length > 0;
                                        if (!x.product.user) {
                                            return <p></p>;
                                        }
                                        return (
                                            <div
                                                key={x.id}
                                                className="grid grid-cols-2 gap-y-2 lg:grid-cols-5 h-full justify-center items-center"
                                            >
                                                <div className="w-4 hidden">
                                                    <div className="flex items-center">
                                                        <input
                                                            id="checkbox-table-search-1"
                                                            type="checkbox"
                                                            className="w-[18px] h-[18px] text-blue-600 bg-white border border-black-10 rounded"
                                                            checked={isActive}
                                                            onChange={(e) => {
                                                                if (
                                                                    !e.target
                                                                        .checked
                                                                ) {
                                                                    let newItems =
                                                                        selectedItems.filter(
                                                                            (
                                                                                y
                                                                            ) =>
                                                                                y
                                                                                    .product
                                                                                    ._id !==
                                                                                x
                                                                                    .product
                                                                                    ._id
                                                                        );
                                                                    setSelectedItems(
                                                                        newItems
                                                                    );
                                                                } else {
                                                                    setSelectedItems(
                                                                        [
                                                                            ...selectedItems,
                                                                            x,
                                                                        ]
                                                                    );
                                                                }
                                                            }}
                                                        />
                                                        <label
                                                            htmlFor="checkbox-table-search-1"
                                                            className="sr-only"
                                                        ></label>
                                                    </div>
                                                </div>
                                                <div className="whitespace-nowrap w-fit col-span-2 sm:col-span-1 lg:col-span-2 flex items-center justify-center">
                                                    <div className="flex items-center mr-2">
                                                        <Checkbox
                                                            checked={isActive}
                                                            onChange={(e) => {
                                                                if (
                                                                    !e.target
                                                                        .checked
                                                                ) {
                                                                    let newItems =
                                                                        selectedItems.filter(
                                                                            (
                                                                                y
                                                                            ) =>
                                                                                y
                                                                                    .product
                                                                                    ._id !==
                                                                                x
                                                                                    .product
                                                                                    ._id
                                                                        );
                                                                    setSelectedItems(
                                                                        newItems
                                                                    );
                                                                } else {
                                                                    setSelectedItems(
                                                                        [
                                                                            ...selectedItems,
                                                                            x,
                                                                        ]
                                                                    );
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    <div className=" flex items-center justify-start">
                                                        <img
                                                            src={
                                                                x.product.images
                                                            }
                                                            alt=""
                                                            className="w-24 h-24 rounded-lg mr-[18px]"
                                                        />
                                                        <div className="">
                                                            <h4 className="text-md font-medium text-black-100 mb-0.5 overflow-text max-w-[250px]">
                                                                {x.product.name}
                                                                <p className="text-md font-medium text-black-50">
                                                                    {
                                                                        x
                                                                            .product
                                                                            .code
                                                                    }
                                                                </p>
                                                            </h4>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="ml-5 lg:ml-0 col-span-2 sm:col-span-1 md:col-auto">
                                                    <div className="flex items-start justify-between mr-2">
                                                        <img
                                                            src={getImage(
                                                                x.product.user
                                                                    .attachment,
                                                                "product"
                                                            )}
                                                            className="w-[48px] h-[48px] rounded-full mr-2"
                                                            alt=""
                                                        />
                                                        <div className="mr-3">
                                                            <h5 className="text-md text-black-60 capitalize overflow-text">
                                                                {
                                                                    x.product
                                                                        .user
                                                                        .userName
                                                                }
                                                            </h5>
                                                            <div className="flex items-center space-x-px">
                                                                <span>
                                                                    <svg
                                                                        width="12"
                                                                        height="11"
                                                                        viewBox="0 0 12 11"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M5.95117 0L7.29826 4.1459H11.6575L8.1308 6.7082L9.47788 10.8541L5.95117 8.2918L2.42446 10.8541L3.77154 6.7082L0.244833 4.1459H4.60409L5.95117 0Z"
                                                                            fill="#FFB800"
                                                                        />
                                                                    </svg>
                                                                </span>
                                                                <span>
                                                                    <svg
                                                                        width="12"
                                                                        height="11"
                                                                        viewBox="0 0 12 11"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M5.95117 0L7.29826 4.1459H11.6575L8.1308 6.7082L9.47788 10.8541L5.95117 8.2918L2.42446 10.8541L3.77154 6.7082L0.244833 4.1459H4.60409L5.95117 0Z"
                                                                            fill="#FFB800"
                                                                        />
                                                                    </svg>
                                                                </span>
                                                                <span>
                                                                    <svg
                                                                        width="12"
                                                                        height="11"
                                                                        viewBox="0 0 12 11"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M5.95117 0L7.29826 4.1459H11.6575L8.1308 6.7082L9.47788 10.8541L5.95117 8.2918L2.42446 10.8541L3.77154 6.7082L0.244833 4.1459H4.60409L5.95117 0Z"
                                                                            fill="#FFB800"
                                                                        />
                                                                    </svg>
                                                                </span>
                                                                <span>
                                                                    <svg
                                                                        width="12"
                                                                        height="11"
                                                                        viewBox="0 0 12 11"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M5.95117 0L7.29826 4.1459H11.6575L8.1308 6.7082L9.47788 10.8541L5.95117 8.2918L2.42446 10.8541L3.77154 6.7082L0.244833 4.1459H4.60409L5.95117 0Z"
                                                                            fill="#FFB800"
                                                                        />
                                                                    </svg>
                                                                </span>
                                                                <span>
                                                                    <svg
                                                                        width="12"
                                                                        height="11"
                                                                        viewBox="0 0 12 11"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M5.95117 0L7.29826 4.1459H11.6575L8.1308 6.7082L9.47788 10.8541L5.95117 8.2918L2.42446 10.8541L3.77154 6.7082L0.244833 4.1459H4.60409L5.95117 0Z"
                                                                            fill="#FFB800"
                                                                        />
                                                                    </svg>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <p className="ml-auto lg:m-0 text-md font-medium text-orange-color whitespace-nowrap capitalize text-right">
                                                            {
                                                                x.product
                                                                    .warehouse
                                                                    .purcharse
                                                            }{" "}
                                                            sold
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="ml-5 lg:ml-0 ">
                                                    <div className="flex items-center lg:justify-center">
                                                        <div className="grid grid-cols-3 w-[74px] h-[26px] rounded-[4px] mr-2.5">
                                                            <button
                                                                onClick={() =>
                                                                    updateCartProductItem(
                                                                        x
                                                                            .product
                                                                            ._id,
                                                                        x.quantity,
                                                                        false
                                                                    )
                                                                }
                                                                className="flex justify-center items-center border-[0.6px] border-black-20 border-r-0 rounded-tl-[4px]  rounded-bl-[4px]"
                                                            >
                                                                <svg
                                                                    width="8"
                                                                    height="2"
                                                                    viewBox="0 0 8 2"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        d="M7.33463 0.666504H0.667969"
                                                                        stroke="black"
                                                                        strokeOpacity="0.3"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                </svg>
                                                            </button>

                                                            <span className="flex justify-center items-center p-1.5 border-[0.6px] border-black-20 text-extraSmall text-ebony-color font-medium">
                                                                {x.quantity}
                                                            </span>

                                                            <button
                                                                onClick={() =>
                                                                    updateCartProductItem(
                                                                        x
                                                                            .product
                                                                            ._id,
                                                                        x.quantity,
                                                                        true
                                                                    )
                                                                }
                                                                className="flex justify-center items-center border-[0.6px] border-black-20 border-l-0  rounded-tr-[4px] rounded-br-[4px]"
                                                            >
                                                                <svg
                                                                    width="14"
                                                                    height="14"
                                                                    viewBox="0 0 14 14"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        d="M6.66732 3.3335V6.66683M6.66732 6.66683V10.0002M6.66732 6.66683H10.0006M6.66732 6.66683L3.33398 6.66683"
                                                                        stroke="black"
                                                                        strokeOpacity="0.3"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                </svg>
                                                            </button>
                                                        </div>

                                                        <p
                                                            onClick={() => {
                                                                Swal.fire({
                                                                    icon: "warning",
                                                                    title: "Remove from cart?",
                                                                    text: "You need to add to cart again to checkout",
                                                                    confirmButtonText:
                                                                        "Remove",
                                                                    showConfirmButton: true,
                                                                    showCancelButton: true,
                                                                    customClass:
                                                                        {
                                                                            cancelButton:
                                                                                "order-1 right-gap",
                                                                            confirmButton:
                                                                                "order-2",
                                                                            denyButton:
                                                                                "order-3",
                                                                        },
                                                                }).then(
                                                                    (res) => {
                                                                        if (
                                                                            res.isConfirmed
                                                                        ) {
                                                                            handleDelete(
                                                                                x
                                                                                    .product
                                                                                    ._id
                                                                            );
                                                                        }
                                                                    }
                                                                );
                                                            }}
                                                            className="text-md font-medium text-orange-color capitalize"
                                                        >
                                                            Remove
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className=" text-md font-medium text-orange-color text-right whitespace-nowrap">
                                                    {x.product.currency}{" "}
                                                    {x.product.price}
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>

                        <div className="flex items-center justify-between mt-10 w-full">
                            <button
                                disabled={selectedItems.length === 0}
                                onClick={() => {
                                    if (selectedItems.length > 0) {
                                        setMode("Address");
                                    }
                                }}
                                className="text-md font-bold text-white py-2.5 px-10 bg-orange-color capitalize rounded-lg"
                            >
                                Checkout
                            </button>
                            <p className="text-md font-medium text-black-50 capitalize">
                                total{" "}
                                <span className="text-orange-color ml-1">
                                    {currency}{" "}
                                    {(
                                        totalProductPrice + totalShippingFee
                                    ).toFixed(2)}
                                </span>
                            </p>
                        </div>
                    </div>
                ) : mode === "Address" ? (
                    <div className="flex flex-col md:flex-row gap-4">
                        <div className="flex-1">
                            <Accordion
                                allowZeroExpanded
                                preExpanded={["one1"]}
                                className="rounded-lg border border-black-10 mb-3"
                            >
                                <AccordionItem uuid="one1" className="active">
                                    <AccordionItemHeading
                                        onClick={(e) => handleAccordionOne(e)}
                                    >
                                        <AccordionItemButton className="p-4 before:hidden flex justify-between items-center accordionToggleOne">
                                            <h3 className="text-md font-medium text-black-60 capitalize">
                                                Saved address
                                            </h3>
                                            <span
                                                className={`${
                                                    !accordionOne &&
                                                    "rotate-180"
                                                }`}
                                            >
                                                <svg
                                                    width="10"
                                                    height="6"
                                                    viewBox="0 0 10 6"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M1.33203 4.5835L4.91962 1.021L8.50721 4.5835"
                                                        stroke="black"
                                                        strokeOpacity="0.5"
                                                        strokeWidth="1.1875"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </span>
                                        </AccordionItemButton>
                                    </AccordionItemHeading>{" "}
                                    <AccordionItemPanel className="p-2 pt-0">
                                        <List>
                                            {deliveryAddresses &&
                                                deliveryAddresses.map(
                                                    (item) => {
                                                        return (
                                                            <ListItem
                                                                classes={{
                                                                    root: "p-1",
                                                                }}
                                                                disableGutters
                                                            >
                                                                <ListItemText
                                                                    style={{
                                                                        maxWidth:
                                                                            "80%",
                                                                    }}
                                                                    classes={{
                                                                        multiline:
                                                                            "my-0",
                                                                    }}
                                                                    primary={
                                                                        <span className="font-black">
                                                                            {
                                                                                item.name
                                                                            }
                                                                        </span>
                                                                    }
                                                                    secondary={
                                                                        <span className="font-black text-black">
                                                                            {item.address +
                                                                                "," +
                                                                                item.subAddress +
                                                                                "," +
                                                                                item.city +
                                                                                "-" +
                                                                                item.postCode}
                                                                            <br />
                                                                            {
                                                                                item.state
                                                                            }
                                                                            ,
                                                                            {item.country ===
                                                                            "+60"
                                                                                ? "Malaysia"
                                                                                : item.country ===
                                                                                  "+1"
                                                                                ? "United States"
                                                                                : "Singapore"}
                                                                            <br />
                                                                            {
                                                                                item.phone
                                                                            }
                                                                            ,
                                                                            {
                                                                                item.email
                                                                            }
                                                                        </span>
                                                                    }
                                                                />
                                                                <ListItemSecondaryAction>
                                                                    <Checkbox
                                                                        checked={
                                                                            selectedAddress._id ===
                                                                            item._id
                                                                        }
                                                                        disabled={
                                                                            isNew
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            handleChecked(
                                                                                item,
                                                                                e
                                                                                    .target
                                                                                    .checked
                                                                            )
                                                                        }
                                                                    />
                                                                </ListItemSecondaryAction>
                                                            </ListItem>
                                                        );
                                                    }
                                                )}
                                        </List>
                                    </AccordionItemPanel>
                                </AccordionItem>
                            </Accordion>

                            <Accordion
                                allowZeroExpanded
                                className="rounded-lg border border-black-10"
                            >
                                <AccordionItem className="active">
                                    <AccordionItemHeading
                                        onClick={(e) => handleAccordionTwo(e)}
                                    >
                                        <AccordionItemButton className="p-4 before:hidden flex justify-between items-center accordionToggleTwo">
                                            <h3 className="text-md font-medium text-black-60 capitalize">
                                                New address
                                            </h3>
                                            <span
                                                className={`${
                                                    !accordionTwo &&
                                                    "rotate-180"
                                                }`}
                                            >
                                                <svg
                                                    width="10"
                                                    height="6"
                                                    viewBox="0 0 10 6"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M1.33203 4.5835L4.91962 1.021L8.50721 4.5835"
                                                        stroke="black"
                                                        strokeOpacity="0.5"
                                                        strokeWidth="1.1875"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </span>
                                        </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel className="p-4 pt-0 ">
                                        <Grid container spacing={1}>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={6}
                                                lg={6}
                                            >
                                                <TextField
                                                    fullWidth
                                                    label="Name"
                                                    placeholder="Name"
                                                    value={name}
                                                    margin="dense"
                                                    onChange={(e) =>
                                                        setName(e.target.value)
                                                    }
                                                    variant="outlined"
                                                    color="primary"
                                                    error={
                                                        form &&
                                                        IsNullOrEmpty(name)
                                                    }
                                                    helperText={
                                                        form &&
                                                        IsNullOrEmpty(name)
                                                            ? "Name is required"
                                                            : ""
                                                    }
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={6}
                                                lg={6}
                                            >
                                                <TextField
                                                    variant="outlined"
                                                    margin="dense"
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <ReactFlagsSelect
                                                                    className="react-select"
                                                                    selected={
                                                                        selected
                                                                    }
                                                                    onSelect={(
                                                                        code
                                                                    ) =>
                                                                        handleSelect(
                                                                            code
                                                                        )
                                                                    }
                                                                    countries={[
                                                                        "MY",
                                                                        "SG",
                                                                        "US",
                                                                    ]}
                                                                    customLabels={{
                                                                        MY: "Malaysia +60",
                                                                        SG: "Singapore +65",
                                                                        US: "United States +1",
                                                                    }}
                                                                />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                    fullWidth
                                                    helperText={
                                                        form &&
                                                        (IsNullOrEmpty(phone) ||
                                                            !validPhone(phone))
                                                            ? "Phone Should be valid and not empty"
                                                            : ""
                                                    }
                                                    error={
                                                        form &&
                                                        (IsNullOrEmpty(phone) ||
                                                            !validPhone(phone))
                                                    }
                                                    label="Phone number"
                                                    placeholder="Phone number"
                                                    value={phone}
                                                    onChange={(e) => {
                                                        setPhone(
                                                            e.target.value
                                                        );
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <TextField
                                                    fullWidth
                                                    label="House number, Unit number"
                                                    placeholder="House number, Unit number"
                                                    onChange={(e) =>
                                                        setAddress(
                                                            e.target.value
                                                        )
                                                    }
                                                    value={address}
                                                    margin="dense"
                                                    variant="outlined"
                                                    color="primary"
                                                    error={
                                                        form &&
                                                        IsNullOrEmpty(address)
                                                    }
                                                    helperText={
                                                        form &&
                                                        IsNullOrEmpty(address)
                                                            ? "Address is required"
                                                            : ""
                                                    }
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={6}
                                                lg={6}
                                            >
                                                <TextField
                                                    fullWidth
                                                    label="Block/road"
                                                    placeholder="Block/road"
                                                    onChange={(e) =>
                                                        setAddress1(
                                                            e.target.value
                                                        )
                                                    }
                                                    value={address1}
                                                    margin="dense"
                                                    variant="outlined"
                                                    color="primary"
                                                    error={
                                                        form &&
                                                        IsNullOrEmpty(address1)
                                                    }
                                                    helperText={
                                                        form &&
                                                        IsNullOrEmpty(address1)
                                                            ? "Address1 is required"
                                                            : ""
                                                    }
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={6}
                                                lg={6}
                                            >
                                                <TextField
                                                    fullWidth
                                                    label="Postcode"
                                                    placeholder="Postcode"
                                                    margin="dense"
                                                    onChange={(e) =>
                                                        setPostCode(
                                                            e.target.value
                                                        )
                                                    }
                                                    onBlur={(e) => {
                                                        fetch(
                                                            `https://maps.googleapis.com/maps/api/geocode/json?components=country:${getCountryByCode(
                                                                countryCode
                                                            )}|postal_code:${postCode}&key=${api_key}`
                                                        )
                                                            .then((response) =>
                                                                response.json()
                                                            )
                                                            .then(function (
                                                                response
                                                            ) {
                                                                //parse the response for a list of matching city/state
                                                                var possibleLocalities =
                                                                    geocodeResponseToCityState(
                                                                        response
                                                                    );
                                                                if (
                                                                    possibleLocalities.length ===
                                                                    0
                                                                ) {
                                                                    setPostCode(
                                                                        ""
                                                                    );
                                                                    setStates(
                                                                        []
                                                                    );
                                                                    setCities(
                                                                        []
                                                                    );
                                                                } else {
                                                                    let dat =
                                                                        possibleLocalities.map(
                                                                            (
                                                                                x
                                                                            ) => {
                                                                                return x.city
                                                                                    ? x.city
                                                                                    : x.state;
                                                                            }
                                                                        );
                                                                    setCities(
                                                                        _.uniq(
                                                                            dat
                                                                        )
                                                                    );

                                                                    dat =
                                                                        possibleLocalities.map(
                                                                            (
                                                                                x
                                                                            ) => {
                                                                                return x.state
                                                                                    ? x.state
                                                                                    : x.city;
                                                                            }
                                                                        );
                                                                    setStates(
                                                                        _.uniq(
                                                                            dat
                                                                        )
                                                                    );
                                                                }
                                                            });
                                                    }}
                                                    value={postCode}
                                                    variant="outlined"
                                                    color="primary"
                                                    error={
                                                        form &&
                                                        IsNullOrEmpty(postCode)
                                                    }
                                                    helperText={
                                                        form &&
                                                        IsNullOrEmpty(postCode)
                                                            ? "Postcode is required"
                                                            : ""
                                                    }
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={6}
                                                lg={6}
                                            >
                                                <FormControl
                                                    margin="dense"
                                                    variant="outlined"
                                                    fullWidth
                                                >
                                                    <InputLabel id="demo-simple-select-outlined-label">
                                                        City/ Town
                                                    </InputLabel>
                                                    <Select
                                                        variant="outlined"
                                                        fullWidth
                                                        label="City/ Town"
                                                        placeholder="City/ Town"
                                                        onChange={(e) =>
                                                            setCity(
                                                                e.target.value
                                                            )
                                                        }
                                                        value={city}
                                                        color="primary"
                                                        error={
                                                            form &&
                                                            IsNullOrEmpty(city)
                                                        }
                                                        helperText={
                                                            form &&
                                                            IsNullOrEmpty(city)
                                                                ? "City is required"
                                                                : ""
                                                        }
                                                    >
                                                        {cities.map((x) => {
                                                            return (
                                                                <MenuItem
                                                                    key={x}
                                                                    value={x}
                                                                >
                                                                    {x}
                                                                </MenuItem>
                                                            );
                                                        })}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={6}
                                                lg={6}
                                            >
                                                <FormControl
                                                    margin="dense"
                                                    variant="outlined"
                                                    fullWidth
                                                >
                                                    <InputLabel id="demo-simple-select-outlined-label">
                                                        State/ Region
                                                    </InputLabel>
                                                    <Select
                                                        fullWidth
                                                        label="State/region"
                                                        placeholder="State/region"
                                                        onChange={(e) =>
                                                            setCurState(
                                                                e.target.value
                                                            )
                                                        }
                                                        value={state}
                                                        variant="outlined"
                                                        color="primary"
                                                        error={
                                                            form &&
                                                            IsNullOrEmpty(state)
                                                        }
                                                        helperText={
                                                            form &&
                                                            IsNullOrEmpty(state)
                                                                ? "State is required"
                                                                : ""
                                                        }
                                                    >
                                                        {states.map((x) => {
                                                            return (
                                                                <MenuItem
                                                                    key={x}
                                                                    value={x}
                                                                >
                                                                    {x}
                                                                </MenuItem>
                                                            );
                                                        })}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={6}
                                                lg={6}
                                            >
                                                <TextField
                                                    fullWidth
                                                    label="Email"
                                                    placeholder="Email"
                                                    margin="dense"
                                                    onChange={(e) =>
                                                        setEmail(e.target.value)
                                                    }
                                                    value={email}
                                                    variant="outlined"
                                                    color="primary"
                                                    helperText={
                                                        form &&
                                                        (IsNullOrEmpty(email) ||
                                                            !validEmail(email))
                                                            ? "Email Should be valid and not empty"
                                                            : ""
                                                    }
                                                    error={
                                                        form &&
                                                        (IsNullOrEmpty(email) ||
                                                            !validEmail(email))
                                                    }
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={6}
                                                lg={6}
                                            >
                                                <TextField
                                                    fullWidth
                                                    label="Save as"
                                                    margin="dense"
                                                    placeholder="Save as"
                                                    onChange={(e) =>
                                                        setNickName(
                                                            e.target.value
                                                        )
                                                    }
                                                    value={nickName}
                                                    variant="outlined"
                                                    color="primary"
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                lg={6}
                                                md={6}
                                            >
                                                <Button
                                                    fullWidth
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={handleAccordionTwo}
                                                    className="btn btn-disabled btn-small"
                                                >
                                                    Cancel
                                                </Button>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                lg={6}
                                                md={6}
                                            >
                                                <Button
                                                    fullWidth
                                                    variant="contained"
                                                    color="primary"
                                                    className="btn btn-blue-new btn-small"
                                                    onClick={() => handleSave()}
                                                >
                                                    Save
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </AccordionItemPanel>
                                </AccordionItem>
                            </Accordion>
                        </div>
                        <div className="flex-1 lg:flex-none lg:w-[500px] rounded-lg border border-black-10 p-4 h-fit">
                            <h3 className="text-xl text-ebony-color font-medium mb-3.5">
                                Details
                            </h3>

                            <div className="mb-[18px]">
                                {selectedItems.map((cartItem, index) => {
                                    currency = cartItem.product.currency;
                                    return (
                                        <div className="flex items-center w-full p-4 rounded-[5px] border border-black-10 mb-1.5">
                                            <img
                                                src={cartItem.product.images}
                                                alt=""
                                                className="w-12 h-12 mr-1.5 rounded-lg"
                                            />
                                            <div className="w-full">
                                                <div className="flex justify-between items-center">
                                                    <h4 className="text-md font-bold text-black-100 capitalize overflow-text max-w-[250px]">
                                                        {cartItem.product.name}
                                                    </h4>
                                                    <p className="text-md text-black-60 uppercase">
                                                        {cartItem.product
                                                            .currency +
                                                            " " +
                                                            cartItem.product
                                                                .price}
                                                    </p>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <h4 className="text-sm font-bold text-black-50 capitalize">
                                                        {cartItem.product.code}{" "}
                                                        <span className="bg-gray-100 text-black-50 text-sm p-1 rounded-full">
                                                            {cartItem.quantity}x
                                                        </span>
                                                    </h4>
                                                    <p
                                                        onClick={() => {
                                                            setSelectedProduct(
                                                                index
                                                            );
                                                            setOpenCourier(
                                                                true
                                                            );
                                                        }}
                                                        className="text-xs text-black-20"
                                                    >
                                                        {calculating
                                                            ? "Calculating"
                                                            : "Shipping fee " +
                                                              cartItem.product
                                                                  .currency +
                                                              " " +
                                                              cartItem.product
                                                                  .shippingFee}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}

                                <div className="text-md text-black-50 capitalize">
                                    <div className="mb-[18px]">
                                        <div className="flex justify-between items-center py-2">
                                            <p>Total shipping fee</p>
                                            <p>
                                                {" "}
                                                {calculating
                                                    ? "Calculating..."
                                                    : (!isNew &&
                                                          !selectedAddress._id) ||
                                                      (isNew &&
                                                          IsNullOrEmpty(
                                                              postCode
                                                          ))
                                                    ? "Calculated at next step"
                                                    : currency +
                                                      " " +
                                                      totalShippingFee.toFixed(
                                                          2
                                                      )}
                                            </p>
                                        </div>
                                        <div className="flex justify-between items-center py-2">
                                            <p>Order Total</p>
                                            <p> {orderTotal}</p>
                                        </div>
                                        <div className="flex justify-between items-center py-2">
                                            <p>Payable Amount</p>
                                            <p className="text-orange-color uppercase">
                                                {currency}{" "}
                                                {(
                                                    totalProductPrice +
                                                    totalShippingFee
                                                ).toFixed(2)}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex items-center">
                                    <button
                                        disabled={
                                            (IsNullOrEmpty(
                                                selectedAddress._id
                                            ) &&
                                                !isNew) ||
                                            calculating ||
                                            validationError
                                        }
                                        onClick={() =>
                                            isNew
                                                ? handleSave()
                                                : setMode("Payment")
                                        }
                                        className="py-[7px] px-3.5 rounded-lg capitalize text-md border border-orange-color bg-orange-color text-white font-bold mr-3"
                                    >
                                        Continue
                                    </button>
                                    <button
                                        onClick={() => setMode("Checkout")}
                                        className="py-[7px] px-3.5 rounded-lg capitalize text-md border border-black-10 bg-white text-black-50 font-medium"
                                    >
                                        cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="grid grid-cols-12 gap-2">
                        <div className="col-span-12 xl:col-span-7 p-4">
                            <div className="flex-1">
                                <h3 className="text-base font-bold text-ebony-color my-2">
                                    Items
                                </h3>
                                <div className="col-span-12 xl:col-span-5 border border-black-10 rounded-lg p-4">
                                    <div className="w-full overflow-x-auto ">
                                        <div className="mb-14">
                                            {selectedItems.map(
                                                (curItem, index) => {
                                                    let curRate = {};

                                                    if (
                                                        rates.length > 0 &&
                                                        selectedItems.length >
                                                            0 &&
                                                        curItem.product &&
                                                        curItem.product._id &&
                                                        selectedRate[
                                                            curItem.product._id
                                                        ]
                                                    ) {
                                                        if (
                                                            rates.length > 0 &&
                                                            rates[index] &&
                                                            rates[index]
                                                                .rates &&
                                                            rates[index].rates
                                                                .length > 0
                                                        ) {
                                                            curRate = _.find(
                                                                rates[index]
                                                                    .rates,
                                                                (x1) =>
                                                                    x1.rate_id ===
                                                                    selectedRate[
                                                                        curItem
                                                                            .product
                                                                            ._id
                                                                    ]
                                                            );
                                                        }
                                                    }
                                                    if (!curItem.product.user) {
                                                        return <p></p>;
                                                    }

                                                    return (
                                                        <div
                                                            key={
                                                                curItem.product
                                                                    .id
                                                            }
                                                            className="flex gap-y-4 flex-col sm:flex-row justify-between mb-6"
                                                        >
                                                            <div className="flex">
                                                                <div className="w-[160px] h-[160px]  mr-4">
                                                                    <img
                                                                        src={
                                                                            curItem
                                                                                .product
                                                                                .images
                                                                        }
                                                                        alt=""
                                                                        className="w-[140px] h-[140px] rounded-lg mr-4"
                                                                    />
                                                                </div>
                                                                <div className="flex w-full">
                                                                    <div className="flex flex-col justify-between mr-2">
                                                                        <div className="">
                                                                            <h4 className="text-md font-medium text-ebony-color mb-0.5 overflow-text max-w-[250px]">
                                                                                {
                                                                                    curItem
                                                                                        .product
                                                                                        .name
                                                                                }
                                                                            </h4>
                                                                            <p className="text-sm font-medium text-black-60">
                                                                                {
                                                                                    curItem
                                                                                        .product
                                                                                        .code
                                                                                }
                                                                            </p>
                                                                        </div>

                                                                        <div className="flex items-center">
                                                                            <div className="mr-3">
                                                                                <h5 className="text-md text-black-60 capitalize overflow-text">
                                                                                    4.9
                                                                                    Rating
                                                                                </h5>
                                                                                <div className="flex items-center space-x-px">
                                                                                    <span>
                                                                                        <svg
                                                                                            width="12"
                                                                                            height="11"
                                                                                            viewBox="0 0 12 11"
                                                                                            fill="none"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                        >
                                                                                            <path
                                                                                                d="M5.95117 0L7.29826 4.1459H11.6575L8.1308 6.7082L9.47788 10.8541L5.95117 8.2918L2.42446 10.8541L3.77154 6.7082L0.244833 4.1459H4.60409L5.95117 0Z"
                                                                                                fill="#FFB800"
                                                                                            />
                                                                                        </svg>
                                                                                    </span>
                                                                                    <span>
                                                                                        <svg
                                                                                            width="12"
                                                                                            height="11"
                                                                                            viewBox="0 0 12 11"
                                                                                            fill="none"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                        >
                                                                                            <path
                                                                                                d="M5.95117 0L7.29826 4.1459H11.6575L8.1308 6.7082L9.47788 10.8541L5.95117 8.2918L2.42446 10.8541L3.77154 6.7082L0.244833 4.1459H4.60409L5.95117 0Z"
                                                                                                fill="#FFB800"
                                                                                            />
                                                                                        </svg>
                                                                                    </span>
                                                                                    <span>
                                                                                        <svg
                                                                                            width="12"
                                                                                            height="11"
                                                                                            viewBox="0 0 12 11"
                                                                                            fill="none"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                        >
                                                                                            <path
                                                                                                d="M5.95117 0L7.29826 4.1459H11.6575L8.1308 6.7082L9.47788 10.8541L5.95117 8.2918L2.42446 10.8541L3.77154 6.7082L0.244833 4.1459H4.60409L5.95117 0Z"
                                                                                                fill="#FFB800"
                                                                                            />
                                                                                        </svg>
                                                                                    </span>
                                                                                    <span>
                                                                                        <svg
                                                                                            width="12"
                                                                                            height="11"
                                                                                            viewBox="0 0 12 11"
                                                                                            fill="none"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                        >
                                                                                            <path
                                                                                                d="M5.95117 0L7.29826 4.1459H11.6575L8.1308 6.7082L9.47788 10.8541L5.95117 8.2918L2.42446 10.8541L3.77154 6.7082L0.244833 4.1459H4.60409L5.95117 0Z"
                                                                                                fill="#FFB800"
                                                                                            />
                                                                                        </svg>
                                                                                    </span>
                                                                                    <span>
                                                                                        <svg
                                                                                            width="12"
                                                                                            height="11"
                                                                                            viewBox="0 0 12 11"
                                                                                            fill="none"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                        >
                                                                                            <path
                                                                                                d="M5.95117 0L7.29826 4.1459H11.6575L8.1308 6.7082L9.47788 10.8541L5.95117 8.2918L2.42446 10.8541L3.77154 6.7082L0.244833 4.1459H4.60409L5.95117 0Z"
                                                                                                fill="#FFB800"
                                                                                            />
                                                                                        </svg>
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <p className="text-xs font-medium text-orange-color whitespace-nowrap capitalize">
                                                                                {
                                                                                    curItem
                                                                                        .product
                                                                                        .warehouse
                                                                                        .purcharse
                                                                                }{" "}
                                                                                sold
                                                                            </p>
                                                                        </div>

                                                                        <div className="flex items-center">
                                                                            <div className="grid grid-cols-3 w-[74px] h-[26px] rounded-[4px] mr-2.5">
                                                                                <button
                                                                                    onClick={() => {
                                                                                        dispatch(
                                                                                            updateCartRequest(
                                                                                                {
                                                                                                    product:
                                                                                                        curItem
                                                                                                            .product
                                                                                                            ._id,
                                                                                                    quantity:
                                                                                                        curItem.quantity -
                                                                                                        1,
                                                                                                }
                                                                                            )
                                                                                        );
                                                                                    }}
                                                                                    className="flex justify-center items-center border-[0.6px] border-black-20 border-r-0 rounded-tl-[4px]  rounded-bl-[4px]"
                                                                                >
                                                                                    <svg
                                                                                        width="8"
                                                                                        height="2"
                                                                                        viewBox="0 0 8 2"
                                                                                        fill="none"
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                    >
                                                                                        <path
                                                                                            d="M7.33463 0.666504H0.667969"
                                                                                            stroke="black"
                                                                                            strokeOpacity="0.3"
                                                                                            strokeLinecap="round"
                                                                                            strokeLinejoin="round"
                                                                                        />
                                                                                    </svg>
                                                                                </button>

                                                                                <span className="flex justify-center items-center p-1.5 border-[0.6px] border-black-20 text-extraSmall text-ebony-color font-medium">
                                                                                    {
                                                                                        curItem.quantity
                                                                                    }
                                                                                </span>

                                                                                <button
                                                                                    onClick={() => {
                                                                                        dispatch(
                                                                                            updateCartRequest(
                                                                                                {
                                                                                                    product:
                                                                                                        curItem
                                                                                                            .product
                                                                                                            ._id,
                                                                                                    quantity:
                                                                                                        curItem.quantity +
                                                                                                        1,
                                                                                                }
                                                                                            )
                                                                                        );
                                                                                    }}
                                                                                    className="flex justify-center items-center border-[0.6px] border-black-20 border-l-0  rounded-tr-[4px] rounded-br-[4px]"
                                                                                >
                                                                                    <svg
                                                                                        width="14"
                                                                                        height="14"
                                                                                        viewBox="0 0 14 14"
                                                                                        fill="none"
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                    >
                                                                                        <path
                                                                                            d="M6.66732 3.3335V6.66683M6.66732 6.66683V10.0002M6.66732 6.66683H10.0006M6.66732 6.66683L3.33398 6.66683"
                                                                                            stroke="black"
                                                                                            strokeOpacity="0.3"
                                                                                            strokeLinecap="round"
                                                                                            strokeLinejoin="round"
                                                                                        />
                                                                                    </svg>
                                                                                </button>
                                                                            </div>

                                                                            <p
                                                                                onClick={() => {
                                                                                    Swal.fire(
                                                                                        {
                                                                                            icon: "warning",
                                                                                            title: "Remove from cart?",
                                                                                            text: "You need to add to cart again to checkout",
                                                                                            confirmButtonText:
                                                                                                "Remove",
                                                                                            showConfirmButton: true,
                                                                                            showCancelButton: true,
                                                                                            customClass:
                                                                                                {
                                                                                                    cancelButton:
                                                                                                        "order-1 right-gap",
                                                                                                    confirmButton:
                                                                                                        "order-2",
                                                                                                    denyButton:
                                                                                                        "order-3",
                                                                                                },
                                                                                        }
                                                                                    ).then(
                                                                                        (
                                                                                            res
                                                                                        ) => {
                                                                                            if (
                                                                                                res.isConfirmed
                                                                                            ) {
                                                                                                handleDelete(
                                                                                                    curItem
                                                                                                        .product
                                                                                                        ._id
                                                                                                );
                                                                                            }
                                                                                        }
                                                                                    );
                                                                                }}
                                                                                className="text-xs font-medium text-orange-color capitalize"
                                                                            >
                                                                                Remove
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="flex flex-row sm:flex-col items-center justify-between sm:items-end sm:justify-end">
                                                                <div className="text-md font-medium text-orange-color sm:mb-5 uppercase order-2 sm:order-1">
                                                                    {
                                                                        curItem
                                                                            .product
                                                                            .currency
                                                                    }{" "}
                                                                    {
                                                                        curItem
                                                                            .product
                                                                            .price
                                                                    }
                                                                </div>
                                                                <div className="order-1 sm:order-2">
                                                                    <TextField
                                                                        fullWidth
                                                                        label="Discount code"
                                                                        placeholder="Discount code"
                                                                        value={
                                                                            discounts[
                                                                                curItem
                                                                                    .product
                                                                                    ._id
                                                                            ]
                                                                                .discountCode
                                                                        }
                                                                        margin="dense"
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            setDiscounts(
                                                                                {
                                                                                    ...discounts,
                                                                                    [curItem
                                                                                        .product
                                                                                        ._id]:
                                                                                        {
                                                                                            discountCode:
                                                                                                e
                                                                                                    .target
                                                                                                    .value,
                                                                                            discount: 0,
                                                                                        },
                                                                                }
                                                                            )
                                                                        }
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        helperText={
                                                                            parseFloat(
                                                                                discounts[
                                                                                    curItem
                                                                                        .product
                                                                                        ._id
                                                                                ]
                                                                                    .discount
                                                                            ) >
                                                                            0
                                                                                ? curItem
                                                                                      .product
                                                                                      .currency +
                                                                                  " " +
                                                                                  discounts[
                                                                                      curItem
                                                                                          .product
                                                                                          ._id
                                                                                  ]
                                                                                      .discount *
                                                                                      curItem.quantity +
                                                                                  " Discount Applied"
                                                                                : ""
                                                                        }
                                                                        InputProps={{
                                                                            endAdornment:
                                                                                (
                                                                                    <InputAdornment position="end">
                                                                                        <button
                                                                                            onClick={() => {
                                                                                                if (
                                                                                                    discounts[
                                                                                                        curItem
                                                                                                            .product
                                                                                                            ._id
                                                                                                    ]
                                                                                                        .discountCode ===
                                                                                                    curItem
                                                                                                        .product
                                                                                                        .discountCode
                                                                                                ) {
                                                                                                    let dis =
                                                                                                        ((parseFloat(
                                                                                                            curItem
                                                                                                                .product
                                                                                                                .price
                                                                                                        ) +
                                                                                                            parseFloat(
                                                                                                                curItem
                                                                                                                    .product
                                                                                                                    .shippingFee
                                                                                                            )) *
                                                                                                            parseFloat(
                                                                                                                curItem
                                                                                                                    .product
                                                                                                                    .discountPer
                                                                                                            )) /
                                                                                                        100;
                                                                                                    setSelectedItems(
                                                                                                        selectedItems.map(
                                                                                                            (
                                                                                                                zt
                                                                                                            ) => {
                                                                                                                if (
                                                                                                                    zt
                                                                                                                        .product
                                                                                                                        ._id ===
                                                                                                                    curItem
                                                                                                                        .product
                                                                                                                        ._id
                                                                                                                ) {
                                                                                                                    zt.product.discount =
                                                                                                                        dis;
                                                                                                                }
                                                                                                                return zt;
                                                                                                            }
                                                                                                        )
                                                                                                    );
                                                                                                    setDiscounts(
                                                                                                        {
                                                                                                            ...discounts,
                                                                                                            [curItem
                                                                                                                .product
                                                                                                                ._id]:
                                                                                                                {
                                                                                                                    discountCode:
                                                                                                                        curItem
                                                                                                                            .product
                                                                                                                            .discountCode,
                                                                                                                    discount:
                                                                                                                        dis,
                                                                                                                },
                                                                                                        }
                                                                                                    );
                                                                                                } else {
                                                                                                    Swal.fire(
                                                                                                        {
                                                                                                            title: "Invalid Discount Code",
                                                                                                            text: "Please provide the valid discount code.",
                                                                                                            icon: "warning",

                                                                                                            confirmButtonText:
                                                                                                                "Close",
                                                                                                            customClass:
                                                                                                                {
                                                                                                                    cancelButton:
                                                                                                                        "order-1 right-gap",
                                                                                                                    confirmButton:
                                                                                                                        "order-2",
                                                                                                                    denyButton:
                                                                                                                        "order-3",
                                                                                                                },
                                                                                                        }
                                                                                                    );
                                                                                                }
                                                                                            }}
                                                                                            className="text-black-50 text-sm py-1 px-2 bg-white border border-[#D1D5DB] rounded-md"
                                                                                        >
                                                                                            Apply
                                                                                        </button>
                                                                                    </InputAdornment>
                                                                                ),
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-span-12 xl:col-span-5 h-fit rounded-lg pt-4 pr-4">
                            <div className="mb-[9px]">
                                <div className="w-full">
                                    <h3 className="text-base font-bold text-ebony-color my-2">
                                        Order Summary
                                    </h3>
                                    <div className="bg-white rounded-full border border-black-10 rounded-xl p-3">
                                        <div className="flex justify-between items-center my-2">
                                            <span className="text-black-50">
                                                Shipping Fee{" "}
                                            </span>
                                            <span className="text-black-50">
                                                {(!isNew &&
                                                    !selectedAddress._id) ||
                                                (isNew &&
                                                    IsNullOrEmpty(postCode))
                                                    ? "Calculated at next step"
                                                    : currency +
                                                      " " +
                                                      totalShippingFee.toFixed(
                                                          2
                                                      )}
                                            </span>
                                        </div>
                                        <div className="flex justify-between items-center my-2">
                                            <span className="text-black-50">
                                                Order Total
                                            </span>
                                            <span className="text-black-50">
                                                {orderTotal}
                                            </span>
                                        </div>
                                        {totalDiscount > 0 && (
                                            <div className="flex justify-between items-center my-2">
                                                <span className="text-black-50">
                                                    Discount
                                                </span>
                                                <span className="text-black-50">
                                                    {currency +
                                                        " " +
                                                        totalDiscount}
                                                </span>
                                            </div>
                                        )}
                                        <div className="flex justify-between items-center my-2">
                                            <span className="text-black-50">
                                                Payable Amount
                                            </span>
                                            <span className="text-orange-color">
                                                {currency}{" "}
                                                {(
                                                    totalProductPrice +
                                                    totalShippingFee -
                                                    totalDiscount
                                                ).toFixed(2)}
                                            </span>
                                        </div>
                                    </div>
                                    <button
                                        className="py-2.5 px-5 mt-4 text-sm rounded-lg border border-transparent bg-orange-color text-white font-bold capitalize float-right"
                                        onClick={() => setConfirmPayment(true)}
                                    >
                                        Proceed to payment
                                    </button>
                                    <Dialog
                                        open={confirmPayment}
                                        onClose={() => setConfirmPayment(false)}
                                    >
                                        <DialogContent>
                                            {confirmPayment &&
                                                selectedItems.length > 0 &&
                                                rates.length > 0 &&
                                                selectedItems
                                                    .map(
                                                        (z) =>
                                                            z.product
                                                                .shippingFee
                                                    )
                                                    .filter((x) => x > 0)
                                                    .length ===
                                                    selectedItems.length && (
                                                    <OrderPayment
                                                        courier={courier}
                                                        items={selectedItems}
                                                        cartId={carts._id}
                                                        totalPrices={(
                                                            totalProductPrice +
                                                            totalShippingFee
                                                        ).toFixed(2)}
                                                        selectedAddress={
                                                            selectedAddress
                                                        }
                                                        shipment={shipment}
                                                        discounts={discounts}
                                                        onCancel={() =>
                                                            setConfirmPayment(
                                                                false
                                                            )
                                                        }
                                                    />
                                                )}
                                        </DialogContent>
                                    </Dialog>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <Dialog
                maxWidth="lg"
                fullWidth
                open={openCourier}
                onClose={() => setOpenCourier(false)}
            >
                <DialogTitle>
                    Courier Selection
                    <CloseRounded
                        className="float-right"
                        onClick={() => setOpenCourier(false)}
                    />
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        {rates.map((xt, index) => {
                            return (
                                <Grid item lg={4} md={4} sm={12} xs={12}>
                                    <div className="border border-secondary p-1 rounded-xl">
                                        <List dense disablePadding>
                                            <ListItem disableGutters>
                                                <ListItemAvatar>
                                                    <Avatar
                                                        src={getImage(
                                                            selectedItems[index]
                                                                .product
                                                                .attachments
                                                        )}
                                                    />
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primaryTypographyProps={{
                                                        className:
                                                            "overflow-text max-w-[250px]",
                                                    }}
                                                    primary={
                                                        <span className="text-black-100 text-md overflow-text max-w-[250px]">
                                                            {
                                                                selectedItems[
                                                                    index
                                                                ].product.name
                                                            }
                                                        </span>
                                                    }
                                                    secondary={
                                                        <span className="text-black-50">
                                                            {
                                                                selectedItems[
                                                                    index
                                                                ].product.code
                                                            }
                                                        </span>
                                                    }
                                                />
                                                <ListItemSecondaryAction>
                                                    <span className="text-black-80">
                                                        {
                                                            selectedItems[index]
                                                                .product
                                                                .currency
                                                        }{" "}
                                                        {
                                                            selectedItems[index]
                                                                .product.price
                                                        }
                                                    </span>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        </List>
                                        <Divider />
                                        {xt.rates
                                            .filter(
                                                (yt) =>
                                                    yt.service_detail.indexOf(
                                                        "dropoff"
                                                    ) > -1
                                            )
                                            .map((yt) => {
                                                return (
                                                    <Grid container>
                                                        <Grid
                                                            item
                                                            sm={12}
                                                            xs={12}
                                                        >
                                                            <List
                                                                dense
                                                                disablePadding
                                                            >
                                                                <ListItem
                                                                    disableGutters
                                                                >
                                                                    <ListItemAvatar>
                                                                        <img
                                                                            width="100"
                                                                            src={
                                                                                yt.courier_logo
                                                                            }
                                                                            className="mr-1"
                                                                        />
                                                                    </ListItemAvatar>
                                                                    <ListItemText
                                                                        primaryTypographyProps={{
                                                                            className:
                                                                                "text-black-100",
                                                                        }}
                                                                        secondaryTypographyProps={{
                                                                            className:
                                                                                "text-black-50",
                                                                        }}
                                                                        primary={
                                                                            yt.courier_name
                                                                        }
                                                                        secondary={
                                                                            userProfile
                                                                                .country
                                                                                .currency +
                                                                            " " +
                                                                            yt.price +
                                                                            " (" +
                                                                            yt.delivery +
                                                                            ")"
                                                                        }
                                                                    />
                                                                    <ListItemSecondaryAction>
                                                                        <Radio
                                                                            checked={
                                                                                yt.rate_id ===
                                                                                selectedRate[
                                                                                    selectedItems[
                                                                                        index
                                                                                    ]
                                                                                        .product
                                                                                        ._id
                                                                                ]
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) => {
                                                                                let id =
                                                                                    selectedItems[
                                                                                        index
                                                                                    ]
                                                                                        .product
                                                                                        ._id;
                                                                                if (
                                                                                    e
                                                                                        .target
                                                                                        .checked
                                                                                ) {
                                                                                    setSelectedRate(
                                                                                        {
                                                                                            ...selectedRate,
                                                                                            [id]: yt.rate_id,
                                                                                        }
                                                                                    );
                                                                                    setShipment(
                                                                                        {
                                                                                            ...shipment,
                                                                                            [id]: yt.shipment_price,
                                                                                        }
                                                                                    );
                                                                                    setCourier(
                                                                                        {
                                                                                            ...courier,
                                                                                            [id]: yt.courier_name,
                                                                                        }
                                                                                    );
                                                                                    setSelectedItems(
                                                                                        selectedItems.map(
                                                                                            (
                                                                                                zt
                                                                                            ) => {
                                                                                                if (
                                                                                                    zt
                                                                                                        .product
                                                                                                        ._id ===
                                                                                                    id
                                                                                                ) {
                                                                                                    zt.product.shippingFee =
                                                                                                        yt.shipment_price;
                                                                                                }
                                                                                                return zt;
                                                                                            }
                                                                                        )
                                                                                    );
                                                                                }
                                                                            }}
                                                                        />
                                                                    </ListItemSecondaryAction>
                                                                </ListItem>
                                                            </List>
                                                        </Grid>
                                                    </Grid>
                                                );
                                            })}
                                    </div>
                                </Grid>
                            );
                        })}
                    </Grid>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default Cart;
